import { jsx as _jsx } from "react/jsx-runtime";
import * as graph from '@adc/sdk';
import Button from '../../elementals/button';
import DownloadLink from '../../downloadLink';
const MEDIA_TYPE_BY_MILESTONE_CODE = {
    CONTRACT_RECEIVED_FROM_SELLER: 'INTERNAL_SELLER_SIGNED_CONTRACT',
};
const MilestonAction = ({ milestone, closing, elmId = 'milestone_action', }) => {
    if (milestone.code in MEDIA_TYPE_BY_MILESTONE_CODE) {
        const mediaType = MEDIA_TYPE_BY_MILESTONE_CODE[milestone.code];
        const relevantMedia = closing?.media?.find(m => m.media_type.includes(mediaType));
        if (relevantMedia) {
            return _jsx(DownloadLink, { resource: relevantMedia });
        }
    }
    if (milestone.code === 'OFFER_DATA_COMPLETED') {
        if (milestone.status === graph.enums.ShallowTaskWorkflowItemStatus.Complete) {
            return null;
        }
        return (_jsx(Button, { role: 'secondary', size: 'small', rel: 'noopener noreferrer', target: '_blank', link: `/contract/${closing?.listing_id}/contract/contact`, elmId: `${elmId}_contract_info_form_button`, children: "Start" }));
    }
    return null;
};
export default MilestonAction;
//# sourceMappingURL=index.js.map